import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'leaflet/dist/leaflet.css';
import { BrowserRouter as Router, Switch, Route, useLocation } from "react-router-dom";

ReactDOM.render(<Router><App /></Router>, document.getElementById('root'));
